const FALLBACK_LOCALE = 'es-AR';

export const resolveForecastLocale = (override) => {
    return (
        override ||
        (typeof navigator !== 'undefined' && navigator.language) ||
        FALLBACK_LOCALE
    );
};

const intl = (override, options) => {
    return new Intl.NumberFormat(resolveForecastLocale(override), options);
};

const toFiniteNumber = (value) => {
    if (value === null || value === undefined) {
        return null;
    }
    if (typeof value === 'string') {
        const trimmed = value.replace(/[^0-9.-]/g, '');
        if (trimmed === '' || trimmed === '-' || trimmed === '.') {
            return null;
        }
    }
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
};

export const formatDecimal = (value, override) => {
    const n = toFiniteNumber(value);
    if (n === null) {
        return '-';
    }
    return intl(override).format(n);
};

export const formatWhole = (value, override) => {
    const n = toFiniteNumber(value);
    if (n === null) {
        return '-';
    }
    return intl(override, { maximumFractionDigits: 0 }).format(n);
};

export const formatSingleDecimal = (value, override) => {
    const n = toFiniteNumber(value);
    if (n === null) {
        return '-';
    }
    return intl(override, {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    }).format(n);
};

/**
 * Frequency is always shown with exactly two decimals: three decimals read as a
 * thousands separator in the locales that use a dot for it (8.668 looks like
 * 8668), which is the confusion this avoids.
 */
export const formatFrequency = (value, override) => {
    const n = toFiniteNumber(value);
    if (n === null) {
        return '-';
    }
    return intl(override, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(n);
};

export const formatPercent = (value, override, { min = 1, max = 1 } = {}) => {
    const n = toFiniteNumber(value);
    if (n === null) {
        return '-';
    }
    return `${intl(override, {
        minimumFractionDigits: min,
        maximumFractionDigits: max,
    }).format(n)}%`;
};

export const formatCoveragePercent = (value, override) => {
    const n = toFiniteNumber(value);
    return `${intl(override, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(n ?? 0)}%`;
};

export const formatRatio = (value, override) => {
    const n = toFiniteNumber(value);
    if (n === null) {
        return '-';
    }
    return `${intl(override, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(n)}x`;
};

export const formatCurrencyValue = (value, currencyCode, override) => {
    const n = toFiniteNumber(value);
    if (n === null) {
        return '-';
    }
    return intl(override, {
        style: 'currency',
        currency: currencyCode || 'USD',
        maximumFractionDigits: 0,
    }).format(n);
};
